const main = () => {
    const content = document.querySelector(".c-others-floating-content");
    if (!content) return;

    let lastScrollY = window.scrollY;
    let isActive = false;

    const handleScroll = () => {
        const currentScrollY = window.scrollY;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;

        // 一番上(scrollY = 0)の場合、data-activeを外す
        if (currentScrollY === 0) {
            if (isActive) {
                content.removeAttribute("data-active");
                isActive = false;
            }
            lastScrollY = currentScrollY;
            return;
        }

        // 一番下に到達した場合、data-activeを外す
        if (currentScrollY + windowHeight >= documentHeight) {
            if (isActive) {
                content.removeAttribute("data-active");
                isActive = false;
            }
            lastScrollY = currentScrollY;
            return;
        }

        // 下にスクロールした場合、data-activeを付与
        if (currentScrollY > lastScrollY && !isActive) {
            content.setAttribute("data-active", "");
            isActive = true;
        }

        lastScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);
};

export default main;
